const ErrorCodesEnum = {
  BAD_CREDENTIALS: 'BCD',
  LOGIN_ATTEMPTS_LIMIT_EXCEEDED: 'LAE',
  ADDED_FROM_MISMATCH: 'AFM',
  INACTIVE_DEALER: 'IND',
  BLOCKED: 'BLK',
};

export default ErrorCodesEnum;
